import { ColorModeBgPropKeys } from 'src/app/styles/colors';
import styled, { css } from 'styled-components';
import { spacingStyles, StyledSpacingProps } from '../Spacing.styles';
import { cssVar } from 'src/app/styles/helper';
import { WidthPropKeys } from 'src/app/styles/spacing';

interface SectionLayoutContainerProps {
  $background?: ColorModeBgPropKeys;
}

export const SectionLayoutContainer = styled.div<SectionLayoutContainerProps>`
  width: 100%;
  position: relative;

  ${({ $background }) =>
    !$background
      ? ''
      : css`
          background: ${cssVar($background)};
        `}
`;

interface SectionLayoutContentProps extends StyledSpacingProps {
  $maxWidth?: WidthPropKeys;
}

export const SectionLayoutContent = styled.div<SectionLayoutContentProps>`
  width: 100%;
  position: relative;

  ${({ $maxWidth }) =>
    !$maxWidth
      ? ''
      : css`
          max-width: ${cssVar($maxWidth)};
        `}

  margin: 0 auto;

  ${spacingStyles}
`;
